import { Flex, Heading } from "@sidelinesports/fan-design-system";
import styles from "./FeaturedMessageAllForNow.module.css";
import ThumbsUp from "./thumbs-up.svg?react";

export const FeaturedMessagesAllForNow = () => (
  <Flex
    align="center"
    direction="column"
    justify="center"
    gap="0.5rem"
    className={styles.box}
  >
    <ThumbsUp />
    <Heading level={4}>That's all for now!</Heading>
  </Flex>
);
